import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";

const sections = [
  { h: "Who we are", p: "NovaAgri Solution LLP is a private facilitation and consultancy service. We assist Indian farmers in preparing and submitting applications for agricultural subsidy schemes, including tractor subsidy and PMKSY micro-irrigation. We are not a government body and we do not approve or guarantee any subsidy." },
  { h: "Information we collect", p: "To help you apply, we collect personal, land, PM-KISAN, bank and tractor requirement details, along with supporting documents such as Aadhaar, land records, bank passbook and quotations. This information is provided by you with consent and used solely for application facilitation." },
  { h: "How we use your data", p: "Your data is used to prepare and submit your subsidy application to the concerned department, to verify document completeness, and to keep you updated on the application status. We do not sell your personal data." },
  { h: "Data protection", p: "We handle Aadhaar and bank data with care under India's DPDP Act 2023 and the Aadhaar Act. Access is limited to authorised staff. Documents are stored securely and retained only as long as needed for your application." },
  { h: "Your rights", p: "You may request access to, correction of, or deletion of your personal data, and withdraw consent at any time by contacting us at support@novaagrisolution.com." },
  { h: "Contact", p: "For any privacy queries, write to support@novaagrisolution.com or call +91 87627 65882. Office: No: 50/33, Chinapanhalli, Marathalli, Bengaluru, Karnataka - 560037." },
];

export default function PrivacyPolicy() {
  return (
    <MarketingLayout>
      <section className="hero-radial grain">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
          <div className="text-sm text-slate-500 mb-4"><Link to="/" className="hover:text-emerald-700">Home</Link> / Privacy Policy</div>
          <h1 className="font-head font-extrabold text-3xl sm:text-4xl text-emerald-950 tracking-tight">Privacy Policy & Disclaimer</h1>
          <p className="mt-4 text-slate-600">Last updated: June 2026</p>
        </div>
      </section>
      <section className="pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-head font-semibold text-xl text-emerald-950">{s.h}</h2>
              <p className="mt-2.5 text-slate-600 leading-relaxed text-[15px]">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
